module.exports = __webpack_public_path__ + "static/media/huli_422.ecf53553.jpg";